import IconContainer from '@/components/IconContainer'

export default function IconEye(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Eye Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M8 2.11243C4.36364 2.11243 1.25818 4.55378 0 7.99995C1.25818 11.4461 4.36364 13.8875 8 13.8875C11.6364 13.8875 14.7418 11.4461 16 7.99995C14.7418 4.55378 11.6364 2.11243 8 2.11243ZM7.99965 11.5245C5.99237 11.5245 4.36328 9.94553 4.36328 7.99999C4.36328 6.05445 5.99237 4.47546 7.99965 4.47546C10.0069 4.47546 11.636 6.05445 11.636 7.99999C11.636 9.94553 10.0069 11.5245 7.99965 11.5245ZM5.81836 7.99997C5.81836 6.82983 6.7929 5.88525 8.00018 5.88525C9.20745 5.88525 10.182 6.82983 10.182 7.99997C10.182 9.17011 9.20745 10.1147 8.00018 10.1147C6.7929 10.1147 5.81836 9.17011 5.81836 7.99997Z" />
    </IconContainer>
  )
}
